import React, { useState } from 'react'
import styles from './ClientOrderList.module.scss'
import { ReactComponent as OpenClient } from 'components/CRM/UI/icons/arrow-down-s-line.svg'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import { pays } from 'components/ContentBox/Global/ListingCards/cats/pays'
import Stores from 'Stores'
import { dateFormat } from 'helpers/date'

const ClientOrderList = ({ index, action, client, translate }) => {
  const [expanded, setExpanded] = useState(false)

  const toggleExpand = () => {
    setExpanded(!expanded)
  }

  const getMenu = (forward_items) =>
    pays
      .find((pay) => pay.link === 'client-orders')
      .colsSettings.action.filter(
        (item) =>
          (item.permission && item.permission[0] === 'forward') ||
          (item.permission &&
            Stores.Rules.checkRule(item.permission[0], item.permission[1]) &&
            (item.active
              ? forward_items[item.active[0]] === item.active[1]
              : true) &&
            (item.dateControl
              ? new Date(forward_items[item.dateControl[0]]) >=
                item.dateControl[1]
              : true) &&
            (item.more ? forward_items[item.more[0]] > item.more[1] : true) &&
            (item.smaller
              ? forward_items[item.smaller[0]] < item.smaller[1]
              : true) &&
            (item.startDate
              ? new Date(
                  `${forward_items[item.startDate[0]]} ${forward_items[item.startDate[1]]}`,
                ) <= item.startDate[2]
              : true) &&
            (item.endDate
              ? new Date(
                  `${forward_items[item.endDate[0]]} ${forward_items[item.endDate[1]]}`,
                ) >= item.endDate[2]
              : true) &&
            (item.unactive
              ? forward_items[item.unactive[0]] !== item.unactive[1]
              : true)),
      )
      .map((action) => ({ name: action.name, action: action.action }))

  function formatClientDate(client) {
    let date = new Date(client)
    let day = String(date.getUTCDate()).padStart(2, '0')
    let month = String(date.getUTCMonth() + 1).padStart(2, '0') // Месяцы начинаются с 0
    let year = date.getUTCFullYear()
    let hours = String(date.getUTCHours()).padStart(2, '0')
    let minutes = (Math.ceil(date.getUTCMinutes() / 5) * 5) % 60

    if (minutes === 0 && date.getUTCMinutes() !== 0) {
      hours = String(parseInt(hours) + 1).padStart(2, '0')
    }

    minutes = String(minutes).padStart(2, '0')

    return `${day}.${month}.${year} ${hours}:${minutes}`
  }

  const lineColor =
    client.status_order === 'paid'
      ? '#1ABC97'
      : client.status_order === 'cancelled'
        ? '#636E72'
        : '#FF0022'

  const [firstPart, secondPart] = client?.description?.split(': ')

  return (
    <>
      <div
        className={`${styles.clientContainer} ${index % 2 === 0 ? styles.colorBg : ''} ${expanded && styles.colorBgActive}`}
        style={{ '--line-color': lineColor }}
      >
        <div className={styles.containerInf}>
          <div
            className={`${styles.infStylOne} ${expanded ? styles.expandedColor : styles.infoStyleColor}`}
          >
            <div className={styles.orderId}>
              {client.order_id}
              <div
                className={styles.verticalSeparator}
                style={{ backgroundColor: expanded ? '#254B77' : '#636E72' }}
              ></div>
            </div>
            <div className={styles.description}>
              <span className={styles.firstPart}>{firstPart}:&nbsp;</span>
              {secondPart && (
                <span className={styles.secondPart}>{secondPart}</span>
              )}
            </div>
          </div>

          <div
            className={`${styles.infStylTwo} ${expanded ? styles.expandedColor : styles.infoStyleColor}`}
          >
            <div className={styles.userName}>
              {client.user_name}
              <div
                className={styles.verticalSeparator}
                style={{ backgroundColor: expanded ? '#254B77' : '#636E72' }}
              ></div>
            </div>

            <div className={styles.createdAt}>
              {formatClientDate(client.created_at)}
            </div>
          </div>

          <div className={styles.blockButtons}>
            <div
              className={`${styles.infStylPrice} ${styles.price} ${
                expanded
                  ? styles.expandedColor
                  : client.status_order === 'paid'
                    ? styles.active
                    : client.status_order === 'cancelled'
                      ? styles.canceled
                      : styles.inActive
              }`}
            >
              {Stores.cleanSumm(client?.amount / 100)} ₸
            </div>
            <div className={styles.buttons}>
              <div
                className={`${styles.buttonClient} ${expanded ? styles.rotate : ''}`}
                onClick={toggleExpand}
              >
                <OpenClient className={styles.btnArrow} />
              </div>
              <ActionMenu
                menu={getMenu(client)}
                action={action}
                items={client}
              />
            </div>
          </div>
        </div>
      </div>

      {expanded && (
        <div className={styles.clientDetails}>
          <div
            className={`${styles.formField} ${styles.clientName}`}
            style={{ gridArea: 'clientName' }}
          >
            <div className={styles.label}>{translate.client_name}:</div>
            <div className={styles.info}>{client.user_name}</div>
          </div>
          <div
            className={`${styles.formField} ${styles.email}`}
            style={{ gridArea: 'email' }}
          >
            <div className={styles.label}>{translate.email}:</div>
            <div className={styles.info}>{client.user_email}</div>
          </div>
          <div
            className={`${styles.formField} ${styles.invoiceValidity}`}
            style={{ gridArea: 'invoiceValidity' }}
          >
            <div className={styles.label}>{translate.payment_date}:</div>
            <div className={styles.info}>
              {dateFormat(
                new Date(
                  client.approved_at ? client.approved_at : client.payment_date,
                ),
                'dd MMMM YYYY г. | hh:ii',
              )}
            </div>
          </div>
          <div
            className={`${styles.formField} ${styles.location}`}
            style={{ gridArea: 'location' }}
          >
            <div className={styles.label}>{translate.location}:</div>
            <div className={styles.info}>{client.location_name}</div>
          </div>
          <div
            className={`${styles.formField} ${styles.INN}`}
            style={{ gridArea: 'INN' }}
          >
            <div className={styles.label}>{translate.inn}:</div>
            <div className={styles.info}>{client.user_inn}</div>
          </div>
          <div
            className={`${styles.formField} ${styles.confirmationDate}`}
            style={{ gridArea: 'confirmationDate' }}
          >
            <div className={styles.label}>
              {translate.invoice_validity_period}:
            </div>
            <div className={styles.info}>
              {client.create_at_bank === null
                ? client.approved_at
                : dateFormat(
                    new Date(
                      client.payment_date
                        ? client.payment_date
                        : new Date(client.payment_expires).setDate(
                            new Date(client.payment_expires).getDate() - 3,
                          ),
                    ),
                    'dd MMMM YYYY г. - ',
                  )}
              {client.create_at_bank === null
                ? client.approved_at
                : dateFormat(
                    new Date(client.payment_expires),
                    'dd MMMM YYYY г.',
                  )}
            </div>
          </div>
          <div
            className={`${styles.formField} ${styles.createdBy}`}
            style={{ gridArea: 'createdBy' }}
          >
            <div className={styles.label}>{translate.created}:</div>
            <div className={styles.info}>{client.created_by_name}</div>
          </div>
          <div
            className={`${styles.formField} ${styles.check}`}
            style={{ gridArea: 'check' }}
          >
            <div className={styles.label}>{translate.check}:</div>
            <div className={styles.info}>
              {client.receipt_number
                ? client.receipt_number
                : translate.without_receipt}
            </div>
          </div>
          <div
            className={`${styles.formField} ${styles.phone}`}
            style={{ gridArea: 'phone' }}
          >
            <div className={styles.label}>{translate.phone}:</div>
            <div className={styles.info}>{client.user_mobile_phone}</div>
          </div>
          <div
            className={`${styles.formField} ${styles.confirmedBy}`}
            style={{ gridArea: 'confirmedBy' }}
          >
            <div className={styles.label}>{translate.confirmed_by}:</div>
            <div className={styles.info}>
              {client.payment_confirmed_name && client.payment_confirmed_name}
            </div>
          </div>
          <div
            className={`${styles.formField} ${styles.bank}`}
            style={{ gridArea: 'bank' }}
          >
            <div className={styles.label}>{translate.bank}:</div>
            <div className={styles.info}>{client.name_bank}</div>
          </div>
          <div
            className={`${styles.formField} ${styles.status}`}
            style={{ gridArea: 'status' }}
          >
            <div className={styles.label}>{translate.status}:</div>
            <div className={styles.info}>
              {client.status_order === 'paid' ? (
                <div className={styles.active}>{translate.paid}</div>
              ) : client.status_order === 'cancelled' ? (
                <div className={styles.canceled}>{translate.canceled}</div>
              ) : (
                <div className={styles.inActive}>{translate.unpaid}</div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ClientOrderList
